import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { color, hoverColor, onHover } from "@m/alchemy-theme";
import { NakedButton } from "../../naked-button/NakedButton";
import { DateTimeIcon } from "../../icons/DateTimeIcon";
import { ScreenReaderContent } from "../../screen-reader-content/ScreenReaderContent";
import { useUniqueId } from "../../hooks/useUniqueId";
export const StyledCalendarButton = styled(NakedButton) `
  padding: 0;
  margin: 0;
  color: ${color("typeMeta")};

  &:not(:disabled) {
    ${onHover(css `
      svg {
        color: ${hoverColor("base", { palette: "interactiveConstructive" })};
      }
    `)}
  }

  &:active:not(:disabled) {
    transform: translate3d(0, 1px, 0);
  }

  &:disabled {
    cursor: default;
    opacity: 0.75;
    &:active {
      color: ${color("typeMeta")};
    }
  }
`;
export const CalendarButton = forwardRef(({ implicitLabelId, label, ...props }, ref) => {
    const buttonId = useUniqueId("cal-label");
    return (_jsxs(StyledCalendarButton, { ref: ref, ...props, noPadding: true, "aria-labelledby": implicitLabelId ? `${implicitLabelId} ${buttonId}` : undefined, children: [_jsx(DateTimeIcon, { "aria-hidden": "true" }), _jsx(ScreenReaderContent, { id: implicitLabelId ? buttonId : undefined, children: label })] }));
});
CalendarButton.displayName = "CalendarButton";
